module.exports = __webpack_public_path__ + "static/media/playbtn.b086c0a1.svg";